import { municipalidadTypes } from "../../types/municipalidadTypes";
import { municipalidadState } from "../../states/municipalidadState";

export const municipalidadReducer = ( state = municipalidadState, action ) => {
    switch ( action.type ) {
		case municipalidadTypes.MUNICIPALIDAD_RESET:
            return { ...state, isLoading: false, listado: [] };

		case municipalidadTypes.MUNICIPALIDAD_GET_START:
            return { ...state, isLoading: true, listado: action.payload };

		case municipalidadTypes.MUNICIPALIDAD_GET_COMPLETE:
            return { ...state, isLoading: false, message: 'Se buscó con éxito', severity: 'success', listado: action.payload };
            
        case municipalidadTypes.MUNICIPALIDAD_GET_ERROR:
            return { ...state, isLoading: false, listado: action.payload };

        default:
            return { ...state };
    }
}
